import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { Trash2Icon, PlusIcon, MinusIcon, ShoppingBagIcon, ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckoutModal } from '../components/CheckoutModal';
export function Cart() {
  const {
    cart,
    removeFromCart,
    updateQuantity,
    cartTotal,
    cartCount
  } = useCart();
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  if (cart.length === 0) {
    return <div className="min-h-[60vh] flex flex-col items-center justify-center px-4" data-id="element-349" data-mp="kq43pivj7qbn">
        <div className="w-20 h-20 bg-slate-50 rounded-full flex items-center justify-center mb-6 text-slate-300" data-id="element-350" data-mp="fqzy127tgaq2">
          <ShoppingBagIcon className="w-10 h-10" data-id="element-351" data-mp="au12cf8i7vpr" />
        </div>
        <h2 className="text-2xl font-black text-slate-900 mb-2 uppercase tracking-tight" data-id="element-352" data-mp="5tddo07qzqyp">
          Your cart is empty
        </h2>
        <p className="text-slate-500 mb-8" data-id="element-353" data-mp="1tbafmmd6phb">
          Looks like you haven't added any wellness essentials yet.
        </p>
        <Link to="/otc-products" className="bg-clinical-blue text-white font-bold py-4 px-8 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs flex items-center gap-2" data-id="element-354" data-mp="29hzycwapig3e">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-355" data-mp="24k7ur50p95jd" /> Start Shopping
        </Link>
      </div>;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-slate-50 min-h-screen py-12 sm:py-20" data-id="element-356" data-mp="2s9snugqkhj6d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-357" data-mp="2j9e2jhdls42v">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-8 sm:mb-12 uppercase tracking-tighter" data-id="element-358" data-mp="2j8um653lpnqy">
          Your Shopping Cart
        </h1>

        <div className="grid lg:grid-cols-3 gap-8 sm:gap-12" data-id="element-359" data-mp="17tpeemom4z0h">
          <div className="lg:col-span-2 space-y-4" data-id="element-360" data-mp="17wbjmfo172fj">
            {cart.map(item => <div key={item.id} className="bg-white p-4 sm:p-6 rounded-2xl border border-slate-100 flex flex-col sm:flex-row gap-4 sm:gap-6 items-start sm:items-center" data-id="element-361" data-mp="1btg4spa89d4h">
                <div className="w-full sm:w-24 h-48 sm:h-24 rounded-xl bg-slate-50 overflow-hidden flex-shrink-0" data-id="element-362" data-mp="34seiwre7kiwf">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-363" data-mp="2ztv0h0ytpp8t" />
                </div>

                <div className="flex-grow w-full" data-id="element-364" data-mp="2qs3v5x873kfh">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-365" data-mp="2qrby0hyy9en3">{item.name}</h3>
                  <p className="text-clinical-blue font-black mb-4" data-id="element-366" data-mp="2lubry723obvz">
                    {item.price}
                  </p>

                  <div className="flex items-center justify-between" data-id="element-367" data-mp="2gwk17gd6yvtd">
                    <div className="flex items-center border border-slate-200 rounded-lg overflow-hidden" data-id="element-368" data-mp="k0w1pb9xcz1j">
                      <button onClick={() => updateQuantity(item.id, -1)} className="p-2 hover:bg-slate-50 text-slate-500 transition-colors" data-id="element-369" data-mp="f3m06x99gwxc">
                        <MinusIcon className="w-4 h-4" data-id="element-370" data-mp="rjvf90apfwcz" />
                      </button>
                      <span className="px-4 font-bold text-slate-900 text-sm" data-id="element-371" data-mp="wcydvmuc9w01">
                        {item.quantity}
                      </span>
                      <button onClick={() => updateQuantity(item.id, 1)} className="p-2 hover:bg-slate-50 text-slate-500 transition-colors" data-id="element-372" data-mp="4liip4epv0y7">
                        <PlusIcon className="w-4 h-4" data-id="element-373" data-mp="dlnq3ejwtzcd" />
                      </button>
                    </div>

                    <button onClick={() => removeFromCart(item.id)} className="text-slate-400 hover:text-red-500 transition-colors p-2" data-id="element-374" data-mp="im1mfzc5fkuk">
                      <Trash2Icon className="w-5 h-5" data-id="element-375" data-mp="1tz46539joqiy" />
                    </button>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="lg:col-span-1" data-id="element-376" data-mp="2xyk94e1d2isp">
            <div className="bg-white p-6 sm:p-8 rounded-2xl border border-slate-100 lg:sticky lg:top-32" data-id="element-377" data-mp="2xzlpmy15bxht">
              <h2 className="text-xl font-black text-slate-900 mb-6 uppercase tracking-tight" data-id="element-378" data-mp="3bz3h5l5ttouv">
                Order Summary
              </h2>

              <div className="space-y-4 mb-8" data-id="element-379" data-mp="3lvg6y7y93ikc">
                <div className="flex justify-between text-slate-500 text-sm" data-id="element-380" data-mp="3lu55iesa2mwe">
                  <span data-id="element-381" data-mp="3gw3lnrn12jjv">Subtotal ({cartCount} items)</span>
                  <span data-id="element-382" data-mp="3uo1ppo1vtp96">${cartTotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-slate-500 text-sm" data-id="element-383" data-mp="3uqe7a03q9xlp">
                  <span data-id="element-384" data-mp="3qn7xwjlbjqb0">Shipping</span>
                  <span className="text-green-600 font-bold uppercase text-[10px] tracking-widest" data-id="element-385" data-mp="8h36tzcst7e3">
                    Calculated at checkout
                  </span>
                </div>
                <div className="pt-4 border-t border-slate-100 flex justify-between items-end" data-id="element-386" data-mp="3g5q7r7fslep">
                  <span className="text-slate-900 font-bold" data-id="element-387" data-mp="n1xtla5xmyrh">Total</span>
                  <span className="text-2xl font-black text-clinical-blue" data-id="element-388" data-mp="s23nkwzocxcq">
                    ${cartTotal.toFixed(2)}
                  </span>
                </div>
              </div>

              <button onClick={() => setCheckoutOpen(true)} className="w-full bg-clinical-blue text-white font-black py-5 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-389" data-mp="i3e1st4nqsr7">
                Proceed to Checkout
              </button>

              <p className="mt-6 text-center text-[10px] text-slate-400 uppercase tracking-widest font-bold" data-id="element-390" data-mp="3vjlhs1miy5uo">
                Secure SSL Encrypted Checkout
              </p>
            </div>
          </div>
        </div>
      </div>
      <CheckoutModal isOpen={checkoutOpen} onClose={() => setCheckoutOpen(false)} data-id="element-391" data-mp="3llnubgchod34" />
    </motion.div>;
}